import { CanvasDataTypes } from '../../../utils';

export const isPhotozoneImage = (object: fabric.Object): boolean => {
  return object.data?.type === CanvasDataTypes.PhotoZoneImage;
};
